import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { subscribeToUnreadCount } from '../services/teamNotificationService';

export const useTeamNotifications = () => {
  const { currentUser } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setUnreadCount(0);
      setLoading(false);
      return;
    }

    setLoading(true);

    // الاستماع للتحديثات المباشرة لعدد الإشعارات غير المقروءة
    const unsubscribe = subscribeToUnreadCount(currentUser.id, (count) => {
      setUnreadCount(count);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, [currentUser]);

  return { unreadCount, loading };
};
